import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6LfSivIrAAAAAJqeqS3h8td-5pUUJ0v0LYct8J5K",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});